import React from 'react';
import useAudioStore from '../store/audioStore';

const reciters = [
  { id: 'ar.alafasy', name: 'Mishary Alafasy', description: 'Saudi Arabia, clear recitation' },
  { id: 'ar.abdulbasit', name: 'Abdul Basit', description: 'Egypt, slow recitation' },
  { id: 'ar.minshawi', name: 'Mohamed Siddiq El-Minshawi', description: 'Egypt, melodious' },
  { id: 'ar.hudhaify', name: 'Ali Al-Hudhaify', description: 'Saudi Arabia, measured pace' },
  { id: 'ar.rifai', name: 'Hani Ar-Rifai', description: 'Saudi Arabia, modern style' },
];

const ReciterSelector = ({ isOpen, onClose }) => {
  const { reciter, setReciter } = useAudioStore();

  const handleSelect = (reciterId) => {
    setReciter(reciterId);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 z-[90]"
        style={{
          background: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(4px)',
        }}
        onClick={onClose}
      />

      {/* Modal */}
      <div 
        className="fixed left-1/2 top-1/2 z-[91] w-full max-w-md p-6 rounded-2xl animate-fade-in"
        style={{
          transform: 'translate(-50%, -50%)',
          background: 'var(--bg-secondary)',
          border: '1px solid var(--border-gold)',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <h2 
              className="text-2xl font-bold"
              style={{ color: 'var(--text-arabic)' }}
            >
              Select Reciter
            </h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center transition-all"
              style={{
                color: 'var(--text-secondary)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(148, 163, 184, 0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              ✕
            </button>
          </div>
          <p 
            className="text-sm"
            style={{ color: 'var(--text-secondary)', opacity: 0.7 }}
          >
            Choose your preferred recitation style
          </p>
        </div>

        {/* Reciters List */}
        <div className="space-y-2">
          {reciters.map((r) => {
            const isSelected = reciter === r.id;
            
            return (
              <button
                key={r.id}
                onClick={() => handleSelect(r.id)}
                className="w-full p-4 rounded-xl text-left transition-all"
                style={{
                  background: isSelected 
                    ? 'var(--gold-muted)' 
                    : 'rgba(148, 163, 184, 0.04)',
                  border: isSelected 
                    ? '2px solid var(--gold-primary)' 
                    : '1px solid var(--border-default)',
                }}
                onMouseEnter={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.background = 'rgba(148, 163, 184, 0.08)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSelected) {
                    e.currentTarget.style.background = 'rgba(148, 163, 184, 0.04)';
                  }
                }}
              >
                <div className="flex items-start gap-3">
                  <div 
                    className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{
                      background: isSelected 
                        ? 'var(--gold-primary)' 
                        : 'rgba(148, 163, 184, 0.1)',
                      color: isSelected ? 'white' : 'var(--text-secondary)',
                    }}
                  >
                    🎙️
                  </div>
                  <div className="flex-1">
                    <h3 
                      className="font-semibold mb-1"
                      style={{ color: isSelected ? 'var(--gold-hover)' : 'var(--text-english)' }}
                    >
                      {r.name}
                      {isSelected && <span className="ml-2">✓</span>}
                    </h3>
                    <p 
                      className="text-sm"
                      style={{ color: 'var(--text-secondary)', opacity: 0.8 }}
                    >
                      {r.description}
                    </p>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ReciterSelector;

